import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "tab-pane fade border border-top-0",
  id: "panel-pre-seminar",
  role: "tabpanel",
  "aria-labelledby": "tab-pre-seminar"
}
const _hoisted_2 = { class: "container p-3" }
const _hoisted_3 = { class: "list-group" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = { class: "mb-0" }
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentations, (presentation, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "list-group-item"
          }, [
            _createElementVNode("h5", {
              class: "mb-1",
              innerHTML: `[${_ctx.presentations.length - index}] ${presentation.title}`
            }, null, 8, _hoisted_4),
            _createElementVNode("p", _hoisted_5, _toDisplayString(presentation.location), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(presentation.date), 1),
            (presentation.hasOwnProperty('note'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "mb-0",
                  innerHTML: presentation.note
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ]))
}